import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../../services/apiAxios';
import helpers from '../../../mixins/helpers';
import moment from 'moment';

const state = {
    objetivosMensuales: [],
    resultados: [],

    objetivosMensualesHistoricos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_OBJETIVOS_MENSUALES' (state) {
        state.objetivosMensuales = [];
    },
    'SET_OBJETIVOS_MENSUALES'(state, objetivosMensuales) {
        state.objetivosMensuales = objetivosMensuales;

        state.objetivosMensuales.forEach(objetivoMensual => {
            objetivoMensual.clientes.forEach(cliente => {
                cliente.objetivoRentabilidadBruta = objetivoMensual.objetivoRentabilidadBruta;
                cliente.periodo = moment(objetivoMensual.periodo).format('YYYY-MM-DD');
            });

            objetivoMensual.clientes = objetivoMensual.clientes.sort((a, b) => {
                // Ordenar primero por "orden" (numérico)
                if (a.orden !== b.orden) {
                    return a.orden - b.orden;
                }
                // Si "orden" es igual, ordenar por "cliente" (texto)
                if (a.cliente && b.cliente) {
                    return a.cliente.localeCompare(b.cliente);
                }
                return 0;
            });
        });
    },
    'INICIALIZAR_OBJETIVOS_MENSUALES_HISTORICOS' (state) {
        state.objetivosMensualesHistoricos = [];
    },
    'SET_OBJETIVOS_MENSUALES_HISTORICOS'(state, objetivosMensualesHistoricos) {
        state.objetivosMensualesHistoricos = objetivosMensualesHistoricos.map(periodo => ({
            periodo: periodo.periodo,
            objetivoVentas: parseFloat(periodo.objetivoVentas),
            objetivoRentabilidadBruta: parseFloat(periodo.objetivoRentabilidadBruta),
            importeFacturar: parseFloat(periodo.importeFacturar),
            importeFacturado: parseFloat(periodo.importeFacturado),
            rentabilidadBrutaEstimada: parseFloat(periodo.rentabilidadBrutaEstimada),
            rentabilidadBrutaReal: parseFloat(periodo.rentabilidadBrutaReal),
            pjeActualObjetivoVentas: parseFloat(periodo.pjeActualObjetivoVentas),
            pjeActualObjetivoRentabilidadBruta: parseFloat(periodo.pjeActualObjetivoRentabilidadBruta),
            pjeActualObjetivoRentabilidadBrutaEstimada: parseFloat(periodo.pjeActualObjetivoRentabilidadBrutaEstimada),
        }));
    },
    'INICIALIZAR_RESULTADOS'(state) {
        state.resultados = [];
    },
    'SET_RESULTADOS'(state, resultados) {
        state.resultados = resultados;
    }
};

const getters = {
    getField,

    objetivosMensuales(state) {
        return state.objetivosMensuales;
    },
    resultados(state) {
        return state.resultados;
    },
    objetivosMensualesHistoricos(state) {
        return state.objetivosMensualesHistoricos;
    },
};

const actions = {
    getObjetivosMensuales ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_OBJETIVOS_MENSUALES');

            apiAxios.get('indicadores/comercial/objetivos-mensuales')
                .then(res => {
                    commit('SET_OBJETIVOS_MENSUALES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    inicializarHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_OBJETIVOS_MENSUALES_HISTORICOS');
            resolve();
        })
    },
    getObjetivosMensualesHistoricos ( { commit } ) {
        return new Promise((resolve, reject) => {
            // commit('INICIALIZAR_OBJETIVOS_MENSUALES_HISTORICOS');

            apiAxios.get('indicadores/comercial/objetivos-mensuales/historico')
                .then(res => {
                    commit('SET_OBJETIVOS_MENSUALES_HISTORICOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getPresupuestosRentabilidadBrutaEstimada ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            apiAxios.get(`indicadores/comercial/rentabilidad-bruta/estimada/${params.clienteId}/presupuestos/${moment(params.periodo).format('YYYY-MM-DD')}`)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getPresupuestosRentabilidadBrutaReal ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            apiAxios.get(`indicadores/comercial/rentabilidad-bruta/real/${params.clienteId}/presupuestos/${moment(params.periodo).format('YYYY-MM-DD')}`)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getFacturacionEstimada ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            let url = `indicadores/comercial/facturacion-estimada/periodo/${moment(params.periodo).format('YYYY-MM-DD')}/clientes`;

            if (params.clienteId) {
                if (params.clienteId != 0) {
                    url += `/${params.clienteId}`;
                }
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },            
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}